import { Suspense, lazy, useEffect, useState } from "react";
import ScrollToTop from "./helpers/scroll-top";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useSearchParams,
} from "react-router-dom";
import {
  getBussinessData,
  getUserPrefersLang,
  saveUserPrefersLang,
  makeRtlCss,
  setUtmParameters,
  getUtmParameters,
  removeUtmParameters,
  getCustomerInfoFromStroge,
  getTokenFromMeta,
  updateTokenFromMeta,
  // UpdateBussinessInfo,
} from "./shared/helpersMethod";
import useGetToken from "./hooks/useGetToken";
import HomeElectronics from "./pages/home/HomeElectronics";
import PaymentFail from "./pages/other/PaymentFail";
import { ToastContainer } from "react-toastify";
import HomeFlowerShop from "./pages/home/HomeFlowerShop";
import useGetHomePage from "./hooks/useGetHomePage";
import Cart from "./pages/other/Cart";
import { store } from "./store/store"; // adjust based on your actual path
import useGetHomeCategory from "./hooks/useGetCategories";
// home pages
// import HomeFashion from "./pages/home/HomeKidsFashion";
// const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));
// const HomeFashionTwo = lazy(() => import("./pages/home/HomeFashionTwo"));
// const HomeFashionThree = lazy(() => import("./pages/home/HomeFashionThree"));
// const HomeFashionFour = lazy(() => import("./pages/home/HomeFashionFour"));
// const HomeFashionFive = lazy(() => import("./pages/home/HomeFashionFive"));
// const HomeFashionSix = lazy(() => import("./pages/home/HomeFashionSix"));
// const HomeFashionSeven = lazy(() => import("./pages/home/HomeFashionSeven"));
// const HomeFashionEight = lazy(() => import("./pages/home/HomeFashionEight"));
// const HomeKidsFashion = lazy(() => import("./pages/home/HomeKidsFashion"));
// const HomeCosmetics = lazy(() => import("./pages/home/HomeCosmetics"));
// const HomeFurniture = lazy(() => import("./pages/home/HomeFurniture"));
// const HomeFurnitureTwo = lazy(() => import("./pages/home/HomeFurnitureTwo"));
const ThankyouPage = lazy(() => import("./pages/other/Thankyou"));
const UnderProcess = lazy(() => import("./pages/other/UnderProcess"));
// const HomeFurnitureThree = lazy(() =>
//   import("./pages/home/HomeFurnitureThree")
// );
// const HomeFurnitureFour = lazy(() => import("./pages/home/HomeFurnitureFour"));
// const HomeFurnitureFive = lazy(() => import("./pages/home/HomeFurnitureFive"));
// const HomeFurnitureSix = lazy(() => import("./pages/home/HomeFurnitureSix"));
// const HomeFurnitureSeven = lazy(() =>
//   import("./pages/home/HomeFurnitureSeven")
// );
// const HomeElectronics = lazy(() => import("./pages/home/HomeElectronics"));
// const HomeElectronicsTwo = lazy(() =>
//   import("./pages/home/HomeElectronicsTwo")
// );
// const HomeElectronicsThree = lazy(() =>
//   import("./pages/home/HomeElectronicsThree")
// );
// const HomeBookStore = lazy(() => import("./pages/home/HomeBookStore"));
// const HomeBookStoreTwo = lazy(() => import("./pages/home/HomeBookStoreTwo"));
// const HomePlants = lazy(() => import("./pages/home/HomePlants"));
// const HomeFlowerShop = lazy(() => import("./pages/home/HomeFlowerShop"));
// const HomeFlowerShopTwo = lazy(() => import("./pages/home/HomeFlowerShopTwo"));
// const HomeOrganicFood = lazy(() => import("./pages/home/HomeOrganicFood"));
// const HomeOrganicFoodTwo = lazy(() =>
//   import("./pages/home/HomeOrganicFoodTwo")
// );
// const HomeOnepageScroll = lazy(() => import("./pages/home/HomeOnepageScroll"));
// const HomeGridBanner = lazy(() => import("./pages/home/HomeGridBanner"));
// const HomeAutoParts = lazy(() => import("./pages/home/HomeAutoParts"));
// const HomeCakeShop = lazy(() => import("./pages/home/HomeCakeShop"));
// const HomeHandmade = lazy(() => import("./pages/home/HomeHandmade"));
// const HomePetFood = lazy(() => import("./pages/home/HomePetFood"));
// const HomeMedicalEquipment = lazy(() =>
//   import("./pages/home/HomeMedicalEquipment")
// );
// const HomeChristmas = lazy(() => import("./pages/home/HomeChristmas"));
// const HomeBlackFriday = lazy(() => import("./pages/home/HomeBlackFriday"));
// const HomeBlackFridayTwo = lazy(() =>
//   import("./pages/home/HomeBlackFridayTwo")
// );
// const HomeValentinesDay = lazy(() => import("./pages/home/HomeValentinesDay"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));
// const ShopGridFilter = lazy(() => import("./pages/shop/ShopGridFilter"));
// const ShopGridTwoColumn = lazy(() => import("./pages/shop/ShopGridTwoColumn"));
// const ShopGridNoSidebar = lazy(() => import("./pages/shop/ShopGridNoSidebar"));
// const ShopGridFullWidth = lazy(() => import("./pages/shop/ShopGridFullWidth"));
// const ShopGridRightSidebar = lazy(() =>
//   import("./pages/shop/ShopGridRightSidebar")
// );
// const ShopListStandard = lazy(() => import("./pages/shop/ShopListStandard"));
// const ShopListFullWidth = lazy(() => import("./pages/shop/ShopListFullWidth"));
// const ShopListTwoColumn = lazy(() => import("./pages/shop/ShopListTwoColumn"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));
// const ProductTabLeft = lazy(() =>
//   import("./pages/shop-product/ProductTabLeft")
// );
// const ProductTabRight = lazy(() =>
//   import("./pages/shop-product/ProductTabRight")
// );
// const ProductSticky = lazy(() => import("./pages/shop-product/ProductSticky"));
// const ProductSlider = lazy(() => import("./pages/shop-product/ProductSlider"));
// const ProductFixedImage = lazy(() =>
//   import("./pages/shop-product/ProductFixedImage")
// );

// blog pages
// const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
// const BlogNoSidebar = lazy(() => import("./pages/blog/BlogNoSidebar"));
// const BlogRightSidebar = lazy(() => import("./pages/blog/BlogRightSidebar"));
// const BlogDetailsStandard = lazy(() =>
//   import("./pages/blog/BlogDetailsStandard")
// );

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));

const NotFound = lazy(() => import("./pages/other/NotFound"));
import { useJsApiLoader } from "@react-google-maps/api";
import TrackOrderPage from "./pages/other/TrackOrder";
import { CSS_VARIABLES } from "./shared/cssVariable";
import Loader from "./components/Loader";
import { processColor } from "./shared/processColor";
import { setUtmParameter } from "./store/slices/utm-slice";
import WindrawLink from "./pages/other/Windraw";
import useGateWays from "./hooks/useBillingGateways";
import FreeInstall from "./pages/custom/Custom101";
import CustomPageRouter from "./pages/custom/CustomPageRouter";
import i18n from "./i18n";
import { useAppSelector } from "./hooks/useReduxMethods";
import usePlaceOrder from "./hooks/usePlaceOrder";
import { AboundedCartInterval, getUserIpInfo } from "./shared/commonUtils";
import ResetScroll from "./components/ResetScroll/ResetScroll";
const App = () => {
  const { loading, getHomePageAllData, homePageAllData } = useGetHomePage();
  const bussinessData = getBussinessData();
  const tokenFromMeta = getTokenFromMeta();
  const curretnLang = getUserPrefersLang();

  const { getToken } = useGetToken();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const [visible, setVisible] = useState(true);
  const { getHomePageCategory } = useGetHomeCategory();
  const { getBillingGateWays } = useGateWays();
  const { abandonedCartApi } = usePlaceOrder();
  const getLatestCartItems = () => {
    const cartItems = store.getState().cart.cartItems;
    console.log(cartItems);
    return cartItems;
  };
  const checkBussinessData = () => {
    // getToken();
    if (bussinessData === null) {
      getToken().then(() => {
        getHomePageAllData().then(() => {
          setTimeout(() => {
            getBillingGateWays();
          }, 1000);
        });
        getHomePageCategory("called 1st time");
      });
      // getToken();
    } else {
      // console.log('hello')
      getHomePageAllData().then(() => {
        setTimeout(() => {
          getBillingGateWays();
        }, 1000);
      });
      getHomePageCategory("called 2nd time");
    }
  };

  const getPixelId = () => {
    console.log(urlParams.get("gclid"));
    var pixel_id = "";
    //  const ttclid = searchParams.get("ttclid");
    if (urlParams.get("ttclid") !== null) {
      pixel_id = urlParams.get("ttclid");
      return pixel_id;
    }
    if (urlParams.get("gclid") !== null) {
      pixel_id = urlParams.get("gclid");
      return pixel_id;
    }
    if (urlParams.get("fbclid") !== null) {
      pixel_id = urlParams.get("fbclid");
      return pixel_id;
    }
    if (urlParams.get("scid") !== null) {
      pixel_id = urlParams.get("scid");
      return pixel_id;
    }
    return pixel_id;
  };
  useEffect(() => {
    updateTokenFromMeta();
  }, []);
  useEffect(() => {
    var orderSourceUrl = window.location.href;
    var pixelId = getPixelId();
    var utmSource = urlParams.get("utm_source");
    var getUtmParam = getUtmParameters();

    checkBussinessData();
    if (curretnLang !== null && curretnLang === "ar") {
      makeRtlCss();
    }

    // Function to derive utm_campaign from document.referrer
    const getDynamicUtmCampaign = (referrer) => {
      if (!referrer) {
        return "Direct"; // Default if no referrer
      }

      try {
        const referrerUrl = new URL(referrer);
        const hostname = referrerUrl.hostname;

        if (hostname.includes("facebook.com")) {
          return "FB URL";
        } else if (hostname.includes("instagram.com")) {
          return "Insta URL";
        } else if (hostname.includes("google.com")) {
          return "Google Search / Ad";
        } else if (hostname.includes("linkedin.com")) {
          return "LinkedIn";
        } else if (
          hostname.includes("twitter.com") ||
          hostname.includes("x.com")
        ) {
          return "Twitter / X";
        } else {
          // For other referrers, you can try to extract the main domain or a more generic label
          const parts = hostname.split(".");
          if (parts.length >= 2) {
            return `${parts[parts.length - 2]} URL`;
          }
          return "Other Social / Referrer";
        }
      } catch (e) {
        console.error("Error parsing referrer URL for campaign:", e);
        return "Invalid Referrer URL";
      }
    };

    // Function to derive utm_medium
    const getDynamicUtmMedium = (url, referrer, existingUtmMedium) => {
      // 1. Prioritize existing utm_medium from URL parameters
      if (existingUtmMedium) {
        return existingUtmMedium;
      }

      // 2. Check for common paid indicators in the URL
      if (
        url.includes("gclid") ||
        url.includes("fbclid") ||
        url.includes("ttclid") ||
        url.includes("msclkid")
      ) {
        return "organic"; // Cost-per-click, commonly associated with paid ads
      }
      if (
        url.includes("utm_medium=paid") ||
        url.includes("utm_medium=ppc") ||
        url.includes("utm_medium=display")
      ) {
        return "paid"; // Explicitly set as paid
      }

      // 3. Infer from referrer for organic/social
      if (referrer) {
        try {
          const referrerUrl = new URL(referrer);
          const hostname = referrerUrl.hostname;

          if (
            hostname.includes("google.com") &&
            (url.includes("q=") || url.includes("search?"))
          ) {
            return "organic_search"; // Google organic search
          } else if (
            hostname.includes("bing.com") &&
            (url.includes("q=") || url.includes("search?"))
          ) {
            return "organic_search"; // Bing organic search
          } else if (
            hostname.includes("yahoo.com") &&
            (url.includes("q=") || url.includes("search?"))
          ) {
            return "organic_search"; // Yahoo organic search
          } else if (
            hostname.includes("facebook.com") ||
            hostname.includes("instagram.com") ||
            hostname.includes("linkedin.com") ||
            hostname.includes("twitter.com") ||
            hostname.includes("x.com") ||
            hostname.includes("pinterest.com")
          ) {
            return "social"; // Social media
          } else if (
            hostname.includes("mail.google.com") ||
            hostname.includes("mail.yahoo.com") ||
            url.includes("email")
          ) {
            return "email"; // Email campaigns
          } else if (hostname.includes("youtube.com")) {
            return "video"; // YouTube
          }
        } catch (e) {
          console.error("Error parsing referrer URL for medium:", e);
          // Fall through to default if referrer parsing fails
        }
      }

      // 4. Default to organic if no other specific medium is identified
      return "organic";
    };

    // Get the existing utm_medium from the URL parameters
    const existingUtmMedium = urlParams.get("utm_medium");

    // New logic for fbclid or missing utm_source with document.referrer
    if (orderSourceUrl.includes("fbclid") && !utmSource) {
      const referrer = document.referrer;
      setUtmParameters({
        order_source_url: orderSourceUrl,
        pixel_id: pixelId,
        utm_source: referrer || "Direct",
        utm_medium: getDynamicUtmMedium(
          orderSourceUrl,
          referrer,
          existingUtmMedium
        ), // Dynamic medium
        utm_campaign: getDynamicUtmCampaign(referrer), // Dynamic campaign
      });
      return; // Exit early as we've handled this specific case
    }

    // Existing logic for other cases
    // We need to ensure utm_medium is set consistently here too
    if (getUtmParam === null && pixelId !== "") {
      if (pixelId !== "") {
        setUtmParameters({
          order_source_url: orderSourceUrl,
          pixel_id: pixelId,
          utm_source: utmSource,
          utm_medium: getDynamicUtmMedium(
            orderSourceUrl,
            document.referrer,
            existingUtmMedium
          ), // Add medium here
        });
      } else {
        if (getUtmParam !== null) {
          setUtmParameters({
            order_source_url: getUtmParam.order_source_url,
            pixel_id: "",
            utm_source: utmSource,
            utm_medium: getDynamicUtmMedium(
              orderSourceUrl,
              document.referrer,
              existingUtmMedium
            ), // Add medium here
          });
        }
      }
    } else {
      if (pixelId === "" && utmSource !== null) {
        setUtmParameters({
          order_source_url: orderSourceUrl,
          pixel_id: "",
          utm_source: utmSource || getUtmParam.utm_source,
          utm_medium: getDynamicUtmMedium(
            orderSourceUrl,
            document.referrer,
            existingUtmMedium
          ), // Add medium here
        });
        return;
      }
      if (getUtmParam !== null) {
        setUtmParameters({
          order_source_url:
            pixelId !== "" ? orderSourceUrl : getUtmParam.order_source_url,
          pixel_id: pixelId !== "" ? pixelId : getUtmParam.pixel_id,
          utm_source: utmSource || getUtmParam.utm_source,
          utm_medium: getDynamicUtmMedium(
            orderSourceUrl,
            document.referrer,
            existingUtmMedium
          ), // Add medium here
        });
      }
    }
  }, []);
  const createPlaceObj = () => {
    var customerInfo = getCustomerInfoFromStroge();
    var newCartItems = [];
    var cartTotalPrice = 0;
    var cartTotalDiscount = 0;
    var cartOriginalTotal = 0;
    var cartItems = getLatestCartItems();
    cartItems.forEach((element) => {
      cartTotalPrice += element.actualPrice;
      cartTotalDiscount += element.discount
        ? parseFloat(element.discount.original_price) -
          element.discount.discounted_price
        : 0;
      cartOriginalTotal += element.actualPrice;
      newCartItems.push({
        id: element.id,
        quantity: element.quantity,
        discount: element.discount,
        actual_price: element.actualPrice,
        price: element.actualPrice ? element.actualPrice : element.price,
        multipleOption: [],
        variation: element.variation,
        discounted_price: element.discountedPrice,
      });
      console.log(element);
    });

    var userIpInfo = getUserIpInfo();
    userIpInfo = {
      ...userIpInfo,
      IPv4: userIpInfo.query,
    };

    var newCustomerObj = {
      name: customerInfo?.name,
      customer_id: customerInfo?.id,
      mobile_number: customerInfo?.mobile_number,
      userIpInfo: userIpInfo,
    };

    var priceObj = {
      total_price: cartTotalPrice.toFixed(2),
      discounted_price: cartTotalDiscount.toFixed(2),
      grand_total: cartTotalPrice,
    };

    var utmInfo = getUtmParameters();
    var extraInfo = {
      campaign_type:
        utmInfo !== null && utmInfo?.utm_source !== null
          ? utmInfo.utm_source
          : "Website",

      ...(utmInfo !== null && utmInfo.pixel_id !== ""
        ? {
            campaign_info: {
              order_source_url: utmInfo.order_source_url,
              pixel_id: utmInfo.pixel_id,
            },
          }
        : {}),
    };

    var finalPlaceOrder = {
      cart: newCartItems,
      customer: newCustomerObj,
      price: priceObj,
      extraInfo: extraInfo,
    };
    return finalPlaceOrder;
  };
  useEffect(() => {
    const timer = setInterval(
      () => {
        var cartItems = getLatestCartItems();
        console.log(Date.now() + ": cartItems ", cartItems);
        var customerInfo = getCustomerInfoFromStroge();

        if (!cartItems && cartItems.length === 0) return;

        const now = Date.now();
        // const abandonedItems = cartItems.filter((item) => {
        //   // return item?.addedAt && now - item?.addedAt >= 10 * 60 * 1000;
        //   console.log(now, item?.addedAt);
        //   return item?.addedAt && now - item?.addedAt >= AboundedCartInterval;
        // });
        const abandonedItems = cartItems;
        // const hasOrderBeenPlaced = localStorage.getItem("orderPlaced");

        if (
          abandonedItems.length > 0
          // && hasOrderBeenPlaced !== "true"
        ) {
          // prevent multiple calls
          console.log(localStorage.getItem("abandonedCartTracked"));
          if (
            (localStorage.getItem("abandonedCartTracked") == null ||
              "false" === localStorage.getItem("abandonedCartTracked")) &&
            null !== customerInfo
          ) {
            var sessionId = localStorage.getItem("abandonedCartSSID");
            if (null == sessionId) {
              sessionId = 0;
            }
            // sessionid
            abandonedCartApi(createPlaceObj(customerInfo), sessionId).then(
              ({ placeOrderData }) => {
                console.log(placeOrderData);
                if (placeOrderData && placeOrderData?.session_id) {
                  if (sessionId != 0) {
                    sessionId = placeOrderData.session_id;
                  }

                  localStorage.setItem("abandonedCartSSID", sessionId);
                  localStorage.setItem("abandonedCartTracked", "true");
                }

                // sessionid
              }
            );
          }
        }
      },

      AboundedCartInterval
    ); // 10 minutes

    return () => clearTimeout(timer);
  }, []);
  // useEffect(() => {
  //   var orderSourceUrl = window.location.href;
  //   var pixelId = getPixelId();
  //   var utmSource = urlParams.get("utm_source");
  //   var getUtmParam = getUtmParameters();

  //   checkBussinessData();
  //   if (curretnLang !== null && curretnLang === "ar") {
  //     makeRtlCss();
  //   }

  //   // Function to derive utm_campaign from document.referrer
  //   const getDynamicUtmCampaign = (referrer) => {
  //     if (!referrer) {
  //       return "Direct / Unknown Referrer"; // Default if no referrer
  //     }

  //     try {
  //       const referrerUrl = new URL(referrer);
  //       const hostname = referrerUrl.hostname;

  //       if (hostname.includes("facebook.com")) {
  //         return "FB URL";
  //       } else if (hostname.includes("instagram.com")) {
  //         return "Insta URL";
  //       } else if (hostname.includes("google.com")) {
  //         return "Google Search / Ad";
  //       } else if (hostname.includes("linkedin.com")) {
  //         return "LinkedIn";
  //       } else if (
  //         hostname.includes("twitter.com") ||
  //         hostname.includes("x.com")
  //       ) {
  //         return "Twitter / X";
  //       } else {
  //         // For other referrers, you can try to extract the main domain or a more generic label
  //         const parts = hostname.split(".");
  //         if (parts.length >= 2) {
  //           return `${parts[parts.length - 2]} URL`;
  //         }
  //         return "Other Social / Referrer";
  //       }
  //     } catch (e) {
  //       console.error("Error parsing referrer URL:", e);
  //       return "Invalid Referrer URL";
  //     }
  //   };

  //   // New logic for fbclid or missing utm_source with document.referrer
  //   if (orderSourceUrl.includes("clid") && !utmSource) {
  //     const referrer = document.referrer;
  //     setUtmParameters({
  //       order_source_url: orderSourceUrl,
  //       pixel_id: pixelId, // Keep existing pixelId logic
  //       utm_source: referrer || "Direct", // Use document.referrer
  //       utm_medium: "organic",
  //       utm_campaign: getDynamicUtmCampaign(referrer), // Dynamic campaign
  //     });
  //     return; // Exit early as we've handled this specific case
  //   }

  //   //TODO:: fix reload url issue replace the old
  //   if (getUtmParam === null && pixelId !== "") {
  //     if (pixelId !== "") {
  //       setUtmParameters({
  //         order_source_url: orderSourceUrl,
  //         pixel_id: pixelId,
  //         utm_source: utmSource,
  //       });
  //     } else {
  //       if (getUtmParam !== null) {
  //         setUtmParameters({
  //           order_source_url: getUtmParam.order_source_url,
  //           pixel_id: "",
  //           utm_source: utmSource,
  //         });
  //       }
  //     }
  //   } else {
  //     if (pixelId === "" && utmSource !== null) {
  //       setUtmParameters({
  //         order_source_url: orderSourceUrl,
  //         pixel_id: "",
  //         utm_source: utmSource || getUtmParam.utm_source,
  //       });
  //       return;
  //     }
  //     if (getUtmParam !== null) {
  //       setUtmParameters({
  //         order_source_url:
  //           pixelId !== "" ? orderSourceUrl : getUtmParam.order_source_url,
  //         pixel_id: pixelId !== "" ? pixelId : getUtmParam.pixel_id,
  //         utm_source: utmSource || getUtmParam.utm_source,
  //       });
  //     }
  //   }
  // }, []);
  useEffect(() => {
    console.log("document.referrer :", document.referrer);
    // console.log(window.location.href);
    const saveLanguage = (language) => {
      // Update or add the 'lang' parameter
      urlParams.set("lang", language);

      // Build the new URL
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      document.cookie = `lang=${language}; path=/; max-age=31536`;
      // Update the browser URL without reloading
      window.history.replaceState(null, "", newUrl);
      i18n.changeLanguage(language);
      saveUserPrefersLang(language);
    };
    if (homePageAllData) {
      //   const processColorData = processColor(
      //     homePageAllData?.site_settings?.buttonColor
      //   );
      //   // siteFeaturedProductPrimaryBackgroundColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.singleBannerColorLeft,
      //     homePageAllData?.site_settings
      //       ?.siteFeaturedProductPrimaryBackgroundColor
      //   );
      //   //siteFeaturedProductSecondaryBackgroundColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.singleBannerColorRight,
      //     homePageAllData?.site_settings
      //       ?.siteFeaturedProductSecondaryBackgroundColor
      //   );
      //   //mouseHoverColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.mouseHoverColor,
      //     homePageAllData?.site_settings?.mouseOverColor
      //   );
      //   //mouseSelectionColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.mouseSelectionColor,
      //     homePageAllData?.site_settings?.mouseSelectionColor
      //   );
      //   //sliderBgColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.sliderBgColor,
      //     homePageAllData?.site_settings?.sliderBackgroundColor
      //   );
      //   //sliderTextColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.sliderTextColor,
      //     homePageAllData?.site_settings?.sliderTextColor
      //   );
      //   //buttonColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.buttonColor,
      //     homePageAllData?.site_settings?.buttonColor
      //   );
      //   //featuredProductColor
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.featuredProductColor,
      //     homePageAllData?.site_settings?.productTextColor
      //   );

      //   //categorySliderBtnColorActive
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.categorySliderBtnColorActive,
      //     homePageAllData?.site_settings?.categorySliderBtnColorActive
      //   );
      //   //categorySliderBtnColorInActive
      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.themeColorLight,
      //     processColorData.backgroundColor
      //   );

      //   document.documentElement.style.setProperty(
      //     CSS_VARIABLES.themeBorder,
      //     processColorData.borderTopColor
      //   );
      //   /////
      // console.log(curretnLang);

      if (curretnLang === null) {
        if (urlParams.get("lang") !== null) {
          saveLanguage(urlParams.get("lang"));
        }
        if (null == urlParams.get("lang")) {
          i18n.changeLanguage(homePageAllData.defaultLang);
          saveUserPrefersLang(homePageAllData.defaultLang);
        }
        if (homePageAllData.defaultLang === "ar") {
          makeRtlCss();
        }
        return;
      }
      if (null !== curretnLang) {
        saveLanguage(curretnLang);
        if (curretnLang === "ar") {
          makeRtlCss();
        }
      }
    }
  }, [homePageAllData]);

  const libraries = ["places", "geometry", "visualization"];

  const { isLoaded } = useJsApiLoader({
    // googleMapsApiKey: "AIzaSyBLf23cbLxmnwF6rtLCEo7Yv5oiX8GCSig", //work based on IP
    googleMapsApiKey: "AIzaSyAODq7uToLl3uj02dzoHA9YSVSsAKW61to", //works based on domain
    // googleMapsApiKey: GOOGLE_MAPS_KEYS.get(GOOGLE_MAPS_API_KEY + ENVIRONMENT)!,
    preventGoogleFontsLoading: false,
    language: "en",
    // region: "Pakistan",
    // @ts-ignore
    libraries: libraries,
  });
  // useEffect(() => {
  //   // Load JSON file dynamically
  //   fetch("/test.json")
  //     .then((response) => response.json())
  //     .then((data) => console.log(data))
  //     .catch((error) =>
  //       console.error("Error loading validation rules:", error)
  //     );
  // }, []);
  const getSelectedComponent = () => {
    // console.log(homePageAllData)
    // slug

    if (homePageAllData && Object.keys(homePageAllData).length > 0) {
      if (homePageAllData?.selectedTheme?.slug === "home-flower-shop") {
        return <HomeFlowerShop />;
      }
      //  home-electronics
      if (homePageAllData?.selectedTheme?.slug === "home-electronics") {
        return <HomeElectronics />;
      }
      if (null == homePageAllData?.selectedTheme?.slug) {
        return <UnderProcess />;
      }
      //  if()
    } else {
      if (!loading && homePageAllData) {
        return <UnderProcess />;
      } else {
        return <Loader />;
      }
    }
  };
  if (!homePageAllData && !loading) return <Loader />;
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route
              // process.env.PUBLIC_URL +
              path="/"
              // ${prod.element}
              // element={window.themeName}
              element={getSelectedComponent()}
            />
            <Route
              path={process.env.PUBLIC_URL + "/test"}
              element={getSelectedComponent()}
            />

            {/* Homepages */}
            {/* <Route
                path={process.env.PUBLIC_URL + "/home-fashion"}
                element={<HomeFashion/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-two"}
                element={<HomeFashionTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-three"}
                element={<HomeFashionThree/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-four"}
                element={<HomeFashionFour/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-five"}
                element={<HomeFashionFive/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-six"}
                element={<HomeFashionSix/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-seven"}
                element={<HomeFashionSeven/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-fashion-eight"}
                element={<HomeFashionEight/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-kids-fashion"}
                element={<HomeKidsFashion/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-cosmetics"}
                element={<HomeCosmetics/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture"}
                element={<HomeFurniture/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-two"}
                element={<HomeFurnitureTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-three"}
                element={<HomeFurnitureThree/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-four"}
                element={<HomeFurnitureFour/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-five"}
                element={<HomeFurnitureFive/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-six"}
                element={<HomeFurnitureSix/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-furniture-seven"}
                element={<HomeFurnitureSeven/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-electronics"}
                element={<HomeElectronicsTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-electronics-two"}
                element={<HomeElectronicsTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-electronics-three"}
                element={<HomeElectronicsThree/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-book-store"}
                element={<HomeBookStore/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-book-store-two"}
                element={<HomeBookStoreTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-plants"}
                element={<HomePlants/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-flower-shop"}
                element={<HomeFlowerShop/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-flower-shop-two"}
                element={<HomeFlowerShopTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-organic-food"}
                element={<HomeOrganicFood/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-organic-food-two"}
                element={<HomeOrganicFoodTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-onepage-scroll"}
                element={<HomeOnepageScroll/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-grid-banner"}
                element={<HomeGridBanner/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-auto-parts"}
                element={<HomeAutoParts/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-cake-shop"}
                element={<HomeCakeShop/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-handmade"}
                element={<HomeHandmade/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-pet-food"}
                element={<HomePetFood/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-medical-equipment"}
                element={<HomeMedicalEquipment/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-christmas"}
                element={<HomeChristmas/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-black-friday"}
                element={<HomeBlackFriday/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-black-friday-two"}
                element={<HomeBlackFridayTwo/>}
              />
              <Route
                path={process.env.PUBLIC_URL + "/home-valentines-day"}
                element={<HomeValentinesDay/>}
              /> */}

            {/* Shop pages */}
            <Route
              path={
                process.env.PUBLIC_URL +
                "/collections/:collectionName/:categoryId"
              }
              element={<ShopGridStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/collections"}
              element={<ShopGridStandard />}
            />

            {/* <Route
              path={process.env.PUBLIC_URL + "/collections/:categoryId"}
              element={<ShopGridStandard />}
            /> */}

            {/* <Route
              path={process.env.PUBLIC_URL + "/shop-grid-standard"}
              element={<ShopGridStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-filter"}
              element={<ShopGridFilter />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-two-column"}
              element={<ShopGridTwoColumn />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-no-sidebar"}
              element={<ShopGridNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-full-width"}
              element={<ShopGridFullWidth />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-right-sidebar"}
              element={<ShopGridRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-standard"}
              element={<ShopListStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-full-width"}
              element={<ShopListFullWidth />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shop-list-two-column"}
              element={<ShopListTwoColumn />}
            /> */}

            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:productName/:id"}
              element={<Product />}
            />

            {/* <Route
              path={process.env.PUBLIC_URL + "/p/:productName/:id"}
              element={<Product />}
            /> */}
            {/* <Route
              path={process.env.PUBLIC_URL + "/product-tab-left/:id"}
              element={<ProductTabLeft />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-tab-right/:id"}
              element={<ProductTabRight />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-sticky/:id"}
              element={<ProductSticky />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-slider/:id"}
              element={<ProductSlider />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/product-fixed-image/:id"}
              element={<ProductFixedImage />}
            /> */}

            {/* Blog pages */}
            {/* <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={<BlogStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-no-sidebar"}
              element={<BlogNoSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-right-sidebar"}
              element={<BlogRightSidebar />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={<BlogDetailsStandard />}
            /> */}

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/:pageSlug"}
              element={<About />}
            />
            {/* <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            /> */}
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/windraw"}
              element={<WindrawLink />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />

            {/* ThankyouPage */}
            <Route
              path={process.env.PUBLIC_URL + "/thank/you"}
              element={<ThankyouPage />}
            />

            {/* Track order page  */}
            <Route
              path={process.env.PUBLIC_URL + "/track/order"}
              element={<TrackOrderPage />}
            />
            <Route path="/payment-failed" element={<PaymentFail />} />
            {/* Track order Page */}
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />

            {/* Custom Pages Routes */}
            {/* https://ncd.iq/cp/free-ac-installs */}
            <Route path="/cp/:pageSlug" element={<CustomPageRouter />} />
            {/* Custom Pages Routes End */}
          </Routes>
          <ToastContainer
            autoClose={3000}
            theme="colored"
            toastClassName={"body-toast-mobile"}
            bodyClassName={"body-toast-mobile"}
            className={"toast-container-mobile"}
          />
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
